"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const class_validator_1 = require("class-validator");
const default_schema_options_1 = require("./default-schema-options");
class User {
    constructor(params) {
        Object.assign(this, params);
    }
    get displayName() {
        return this.fullName || `${this.givenName} ${this.familyName}`.trim() || `service ${this.email}`;
    }
}
__decorate([
    class_validator_1.Allow()
], User.prototype, "userId", void 0);
__decorate([
    class_validator_1.Allow()
], User.prototype, "email", void 0);
__decorate([
    class_validator_1.Allow()
], User.prototype, "emailVerified", void 0);
__decorate([
    class_validator_1.Allow()
], User.prototype, "fullName", void 0);
__decorate([
    class_validator_1.Allow()
], User.prototype, "picture", void 0);
__decorate([
    class_validator_1.Allow()
], User.prototype, "givenName", void 0);
__decorate([
    class_validator_1.Allow()
], User.prototype, "familyName", void 0);
__decorate([], User.prototype, "displayName", null);
__decorate([], User.prototype, "roles", void 0);
User = __decorate([], User);
exports.User = User;
//# sourceMappingURL=user.model.js.map